export default {
  fi: {
    AcceptInvitationScene: {
      title: 'Luo salasana',
      submit: 'Tallenna',
    },
  },
};
